import Address from '@/components/sections/builder/elements/body/store-location/store';
import ElementContentAddresses from '@/components/sections/builder/elements/body/store-location/content';
import ElementSettingAddress from '@/components/sections/builder/elements/body/store-location/setting';
import { AboutUsStoreLocationElementDataType } from '@/components/sections/builder/elements/body/store-location/type';
import { DEFAULT_THEME_COLOR_SCHEME } from '@/components/sections/builder/theme/color';
import { BetweenHorizonalStart } from 'lucide-react';

const defaultData: AboutUsStoreLocationElementDataType = {
  name: 'Store Location',
  header: 'Address',
  limit: 3,
  limitMobile: 1,
  colorScheme: DEFAULT_THEME_COLOR_SCHEME,
  imageRatio: 'adaptToImage',
  padding: {
    top: 20,
    bottom: 20,
    left: 20,
    right: 20,
  },
};

export const ElementPreviewIcon = BetweenHorizonalStart;

const AboutUsStoreLocation = {
  type: 'about_us_addresses',
  group: 'body_about_us',
  defaultData,
  PreviewIcon: ElementPreviewIcon,
  Element: ElementContentAddresses,
  Setting: ElementSettingAddress,
  defaultChilds: [Address],
  childs: [Address],
};

export default AboutUsStoreLocation;
